import { __decorate } from "tslib";
import { Route } from '../core';
var NewContractShopOffersMobile = /*@__PURE__*/ (function () {
    function NewContractShopOffersMobile() {
    }
    NewContractShopOffersMobile.get = function (response) {
        return response;
    };
    NewContractShopOffersMobile = __decorate([
        Route('/vlux/offers/newcontract-shop-offersmobile.json')
    ], NewContractShopOffersMobile);
    return NewContractShopOffersMobile;
}());
export { NewContractShopOffersMobile };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/newcontract-shop-offersmobile.ts
// module id = null
// module chunks = 